import { FormCustomComponent } from '@typesApp/Forms'
import { OverviewInsurerSelection } from '@typesApp/OverviewWidget'
import { AvailableChannelType, ProviderType } from '@typesApp/Insurer'
import { OverviewWidgetInteractionType } from '@components/interactionContext/types'
import {
  CustomOverviewComponent,
  InsurancePanelLinkComponent,
  InsurerLogosComponent,
  InsurerSelectComponent,
  ShoppingActionsComponent,
} from '../types/Overview.types'

// append to channel key if this brand has physical stores
// so that we can differentiate between CUSTOMER_FORM channel
// with and without stores.
const CHANNEL_KEY_HAS_STORE_SUFFIX = '_HAS_STORE'

export const isInsurerLogosComponent = (component: FormCustomComponent): component is InsurerLogosComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'insurer-logos'
    ? true
    : false
}

export const isInsurerSelectComponent = (component: FormCustomComponent): component is InsurerSelectComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'insurer-select'
    ? true
    : false
}

export const isInsurancePanelLinkComponent = (
  component: FormCustomComponent
): component is InsurancePanelLinkComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'insurance-panel-link'
    ? true
    : false
}

export const isShoppingActionsComponent = (component: FormCustomComponent): component is ShoppingActionsComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'shopping-actions'
    ? true
    : false
}

/**
 * @returns a concatenated string from list of channels separated by |
 * If channels contains only CUSTOMER_FORM channel, the _HAS_STORES suffix
 * will be appended if any of the insurers contains IN_STORE channel.
 */
export const getChannelKey = (channels: AvailableChannelType[] = [], hasStores: boolean | undefined): string => {
  if (channels.length === 1 && channels[0] === AvailableChannelType.CUSTOMER_FORM && hasStores) {
    return `${channels[0]}${CHANNEL_KEY_HAS_STORE_SUFFIX}`
  }
  return channels?.join('|') ?? ''
}

export const getProviderType = (channels: AvailableChannelType[] = []): ProviderType => {
  return channels?.includes(AvailableChannelType.ONLINE) ? ProviderType.IN_NETWORK : ProviderType.OUT_OF_NETWORK
}

export const getInteractionType = (
  selection: OverviewInsurerSelection | undefined,
  isInitialView?: boolean
): OverviewWidgetInteractionType => {
  if (isInitialView || !selection?.providerType) return 'select-insurer'
  return selection.providerType === ProviderType.IN_NETWORK ? 'in-network' : 'out-of-network'
}
